import React, { useState } from "react";
import "./form4.css";
import { useNavigate } from "react-router-dom";

const Formta4 = ({ formData, setFormData, setStep }) => {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = "தேர்ந்தெடுக்கவும்";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const HandleNext = (e) => {
    e.preventDefault();
    if (validate()) {
      navigate(setStep(5));
    }
  };

  const handleBack = () => {
    setStep(3);
  }; 

  return (
    <>
      <div className="form4-background">
        <div className="form4-section">
          <h2 className="form4-title">வசிக்கும் இடத்தின் விவரங்கள்(4/7)</h2>
          <form>
            <div className="form4-row">
              {/* <div className="form4-group">
                <label>
                  நாடு<span className="error fs-star">*</span>
                </label>
                <select
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                >
                  <option value="">--தேர்ந்தெடுக்கவும் --</option>
                  <option value="India">இந்தியா</option>
                </select>
                {errors.country && (
                  <span className="error-text">{errors.country}</span>
                )}
              </div> */}

              {/* <div className="form4-group">
                <label>
                  மாநிலம் <span className="error fs-star">*</span>
                </label>
                <select
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                >
                  <option value="">--தேர்ந்தெடுக்கவும் --</option>
                  <option value="Tamil Nadu">தமிழ்நாடு</option>
                </select>
                {errors.state && (
                  <span className="error-text">{errors.state}</span>
                )}
              </div> */}

              <div className="form4-group">
                <label>
                  மாவட்டம்<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="livingPlace"
                  placeholder="வசிக்கும் இடத்தை உள்ளிடவும்"
                   value={formData.livingPlace}
                  onChange={handleChange}
                />
                {errors.livingPlace && (
                  <span className="error-text">{errors.livingPlace}</span>
                )}
              </div>

              <div className="form4-group">
                <label>
                   தற்போதைய வசிப்பிடம்<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="current_living_place"
                  placeholder="தற்போது வசிக்கும் இடத்தை உள்ளிடவும்" 
                  value={formData.current_living_place}
                  onChange={handleChange}
                />
                {errors.current_living_place && (
                  <span className="error-text">{errors.current_living_place}</span>
                )}
              </div>
            </div>

            <div className="form4-btn-group">
              <button type="button" className="back-btn-4" onClick={handleBack}>
                முன்செல்ல
              </button>
              <button type="button" className="submit-btn-4" onClick={HandleNext}>
                தொடர்க
              </button>
            </div>
          </form>
        </div>
      </div>
    </> 
  );
};

export default Formta4;
